import type { QuoteDocument, QuoteFile } from 'paintscout'

/**
 * The first image in a quote's `files` map, for use as "smart content" in presentation fields
 * that want to always show a representative image from the current quote (e.g. a cover-style
 * background). `files` is a plain object keyed by file key, so "first" just means insertion
 * order — there's no other ordering to prefer here.
 */
export function getFirstQuoteImage(args: { quote: QuoteDocument }): QuoteFile | null {
  const { quote } = args
  const keys = Object.keys(quote?.files ?? {})
  return keys.length ? quote.files[keys[0]] : null
}
